var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAthena(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 154,
    height: 32,
    viewBox: "0 0 154 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B40000",
    d: "M22.916 21.559L22.916 21.559 22.42 0.06 18.287 23.503 23.156 32 22.916 21.559"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0001",
    d: "M36.664 32L22.42 0.06 23.156 32 36.664 32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF009F",
    d: "M22.42 0.06L0 32 16.789 32 22.42 0.06"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B40000",
    d: "M12.748 13.839L23.156 32 36.664 32 12.748 13.839"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1919",
    d: "M50.622 22.99h2.26l1.548-3.436h5.95l1.46 3.436h2.295L57.5 7.955 50.622 22.99zm6.842-10.252l2.063 4.81h-4.224l2.16-4.81zM74.538 10.85L74.538 22.991 72.441 22.991 72.441 10.85 69.245 10.85 69.245 8.843 77.726 8.843 77.726 10.85 74.538 10.85M87.3 14.378L93.296 14.378 93.296 8.844 95.394 8.844 95.394 22.99 93.296 22.99 93.296 16.384 87.3 16.384 87.3 22.99 85.203 22.99 85.203 8.844 87.3 8.844 87.3 14.378M112 10.85L106.428 10.85 106.428 14.249 111.838 14.249 111.838 16.256 106.428 16.256 106.428 20.984 112 20.984 112 22.991 104.33 22.991 104.33 8.843 112 8.843 112 10.85M120.361 22.99L122.458 22.99 122.458 13.086 132.596 23.851 132.596 8.844 130.498 8.844 130.498 18.675 120.361 7.882 120.361 22.99M149.805 19.554h-5.952l-1.548 3.436h-2.26l6.879-15.035 6.634 15.035h-2.295l-1.458-3.436zm-.856-2.006l-2.062-4.81-2.16 4.81h4.222z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAthena);
export default __webpack_public_path__ + "static/media/athena.4a4e1276.svg";
export { ForwardRef as ReactComponent };